var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"c-title mt-3"},[_c('div',{class:_vm.tag},[_vm._v(_vm._s(_vm.label))]),(_vm.description !== '')?_c('p',{staticClass:"text-muted"},[_vm._v(_vm._s(_vm.description))]):_vm._e(),_c('hr')])}
var staticRenderFns = []

export { render, staticRenderFns }